import { createFileRoute } from '@tanstack/react-router';

import { PrescriptionsListPage } from '@fields/feature';

export const Route = createFileRoute('/_app/prescriptions')({
  component: PrescriptionsListPage,
});
